export const CIAN_SOURCE_PARAM = 'cian_source';

export const BOOKING_ENTRY_POINT_SOURCE = 'booking_entry_point';

export const BOOKING_ENTRY_POINT_SOURCES = [BOOKING_ENTRY_POINT_SOURCE];
